import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@mui/material';
import Layout from '../../components/layout/Layout';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { isLoggedIn } from '../../components/authProvider/AuthContext';

function FormTab(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

FormTab.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function formProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
    value: index,
  };
}

export default function FormTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathParts = location.pathname.split('/');
  const activeTab = pathParts[2] || 'fees';

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(`/forms/${newValue}`);
  };

  const [value, setValue] = React.useState(activeTab);

  useEffect(() => {
    setValue(activeTab);
  }, [activeTab]);

  useEffect (() => {
    if(!isLoggedIn()) {
      navigate('/login')
    }
  });

  return (
    <Layout>
      <div className="default-bg-color">
        <Tabs
          value={value}
          classes={{ indicator: 'tabsIndicator' }}
          onChange={handleChange}
          aria-label="form tabs"
          variant="scrollable"
          scrollButtons="on"
        >
          <Tab label="Fees" className="text-10 property-details md:text-14 tabs" {...formProps('fees')} />
          <Tab label="Docs" className="text-10 team md:text-14 tabs" {...formProps('docs')} />
          <Tab label="Lien & Title Check" className="text-10 messages md:text-14 tabs" {...formProps('lien-check')} />
        </Tabs>

        <hr className="divider" />

        <div>
          <FormTab value={value} index="fees">
            <div className="border-grey-1 rounded-t-6">
              <Outlet />
            </div>
          </FormTab>
          <FormTab value={value} index="docs">
            <div className="border-grey-1 rounded-t-6">
              <Outlet />
            </div>
          </FormTab>
          <FormTab value={value} index="lien-check">
            <div className="border-grey-1 rounded-t-6">
              <Outlet />
            </div>
          </FormTab>
        </div>
      </div>
    </Layout>
  );
}
